let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("yne3O")).then(() => parcelRequire('ciD6c'));